import { call, put, takeLatest } from "redux-saga/effects";
import { hocKyDangKyApi } from "../../../api/category/hocKyDangKyApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eHocKyDangKyActionIds } from "../../action-types/category/IHocKyDangKyActions";
import { rootActions } from "../../actions/rootActions";

export function* hocKyDangKySaga(): any {
  yield takeLatest(eHocKyDangKyActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(hocKyDangKyApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.hocKyDangKy.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.hocKyDangKy.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
